import { render } from "./ProteinSequenceViewer.vue?vue&type=template&id=4cfe84a6&scoped=true&ts=true"
import script from "./ProteinSequenceViewer.vue?vue&type=script&lang=ts"
export * from "./ProteinSequenceViewer.vue?vue&type=script&lang=ts"

import "./ProteinSequenceViewer.vue?vue&type=style&index=0&id=4cfe84a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfe84a6"]])

export default __exports__